module.exports = __webpack_public_path__ + "img/jingujian.77e5cf00.jpg";